import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import './LandingPage.css';
import logo from './assets/logo.png';
import celularComPrintImage from './assets/celularcomprint.png';
import startUfpiImage from './assets/Captura de tela 2026-03-07 220155.jpg'; // EXTENSÃO CORRIGIDA PARA .JPG
import imagem1 from './assets/imagem1.png';
import imagem from './assets/imagem.png';
import imagem2 from './assets/imagem2.png';
import imagem3 from './assets/imagem3.png';
import barbeiroImg from './assets/Captura de tela 2026-03-11 010925 (1).png';
import playstoreIcon from './assets/playstore.png';

const LandingPage = () => {
    const [init, setInit] = useState(false);
    const [isMenuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadSlim(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    const particlesLoaded = (container) => {
        console.log(container);
    };

    const options = useMemo(
        () => ({
            fullScreen: { enable: false }, // OBRIGA AS PARTÍCULAS A RESPEITAREM O CONTAINER HERO
            background: {
                color: {
                    value: "transparent",
                },
            },
            fpsLimit: 60,
            interactivity: {
                events: {
                    onHover: {
                        enable: true,
                        mode: "grab",
                    },
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                },
                modes: {
                    grab: {
                        distance: 180,
                        links: {
                            opacity: 0.35,
                        },
                    },
                    push: {
                        quantity: 4,
                    },
                },
            },
            particles: {
                color: {
                    value: ["#00AEEF", "#27ae60"],
                },
                links: {
                    color: "random",
                    distance: 160,
                    enable: true,
                    opacity: 0.25,
                    width: 1,
                    triangles: {
                        enable: true,
                        opacity: 0.05,
                    },
                },
                move: {
                    direction: "none",
                    enable: true,
                    outModes: {
                        default: "out",
                    },
                    random: true,
                    speed: 0.5,
                    straight: false,
                },
                number: {
                    density: {
                        enable: true, area: 800,
                    },
                    value: 160,
                },
                opacity: {
                    value: { min: 0.1, max: 0.4 },
                },
                shape: {
                    type: "circle",
                },
                size: {
                    value: { min: 1, max: 3 },
                },
            },
            detectRetina: true,
        }),
        [],
    );

    const handleNavigateToLogin = () => {
        window.location.href = 'https://painel.vectortrackers.com/';
    };

    const scrollToSection = (sectionId) => {
        setMenuOpen(false);
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleMobileLoginClick = () => {
        setMenuOpen(false);
        window.location.href = 'https://painel.vectortrackers.com/';
    }

    if (!init) {
        return null;
    }

    return (
        <div className={`landing-page ${isMenuOpen ? 'no-scroll' : ''}`}>
            <header className="page-header">
                <nav className="navbar">
                    <div className="navbar-container">
                        <div className="navbar-brand">
                            <img src={logo} alt="Vector Tracker Logo" className="navbar-logo" />
                            <span>Vector Tracker</span>
                        </div>
                        <div className="navbar-menu">
                            <button className="navbar-link" onClick={() => scrollToSection('sobre-section')}>
                                Sobre
                            </button>
                            <button className="navbar-link" onClick={() => scrollToSection('baixar-app-card')}>
                                Baixe o app
                            </button>
                            <button className="navbar-link" onClick={() => scrollToSection('contato-section')}>
                                Contato
                            </button>
                        </div>
                        <div className="navbar-actions">
                            <button className="navbar-button" onClick={handleNavigateToLogin}>
                                Acessar o Painel
                            </button>
                        </div>
                        <button className="mobile-menu-button" onClick={() => setMenuOpen(!isMenuOpen)} aria-label="Abrir menu">
                            <div className={`hamburger-icon ${isMenuOpen ? 'open' : ''}`}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </button>
                    </div>
                </nav>
            </header>

            <div className={`mobile-menu-overlay ${isMenuOpen ? 'open' : ''}`}>
                <button className="mobile-menu-close-button" onClick={() => setMenuOpen(false)}>&times;</button>
                <button className="mobile-menu-link" onClick={() => scrollToSection('sobre-section')}>
                    Sobre
                </button>
                <button className="mobile-menu-link" onClick={() => scrollToSection('baixar-app-card')}>
                    Baixe o app
                </button>
                <button className="mobile-menu-link" onClick={() => scrollToSection('contato-section')}>
                    Contato
                </button>
                <button className="mobile-menu-button-login" onClick={handleMobileLoginClick}>
                    Acessar o Painel
                </button>
            </div>

            {/* HERO NO TOPO - TEXTO À ESQUERDA COM TRACKER EM GRADIENTE E INSETO À DIREITA */}
            <div className="hero-container top-hero">
                <div className="hero-content-grid">
                    <div className="hero-text">
                        <div className="text-content-wrapper">
                            <h1>Vector <span className="gradient-text">Tracker</span></h1>
                            <p>
                                Projeto que utiliza tecnologia para auxiliar na identificação e no registro de ocorrências relacionadas ao inseto transmissor da Doença de Chagas, promovendo a aproximação entre comunidade e vigilância em saúde.
                            </p>
                            <div className="download-buttons-group">
                                <a 
                                    href="https://play.google.com/store/apps/details?id=com.vectortrackers.app" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="google-play-button"
                                >
                                    <div className="google-play-content">
                                        <img src={playstoreIcon} alt="Google Play Store" className="playstore-icon-img" />
                                        <div className="google-play-text">
                                            <span className="get-it-on">GET IT ON</span>
                                            <span className="play-brand">Google Play</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="hero-image">
                        <img src={barbeiroImg} alt="Barbeiro" className="top-hero-image" />
                    </div>
                </div>
            </div>

            <main>
                {/* INFOGRÁFICO COMO TRANSIÇÃO (APENAS O DESENHO) */}
                <div className="infographic-transition-area">
                    <div className="infographic-container">
                        <div className="infographic-step-group">
                            <div className="step">
                                <img src={imagem1} alt="Mulher sentada, usando o celular para denunciar" />
                            </div>
                            <div className="step step-phone">
                                <img src={imagem} alt="Celular tirando foto de um inseto" />
                            </div>
                        </div>
                        <div className="arrow">→</div>
                        <div className="step">
                            <img src={imagem3} alt="Agente de saúde conversando com uma moradora na porta de casa" />
                        </div>
                        <div className="arrow">→</div>
                        <div className="step">
                            <img src={imagem2} alt="Agente de saúde analisando os dados no computador" />
                        </div>
                    </div>
                </div>

                <section id="sobre-section">
                    <h2>Sobre</h2>
                    <div className="section-body">
                        <p>
                            Vector Tracker é um projeto dedicado ao monitoramento de triatomíneos (conhecidos como "barbeiros"), os principais vetores da Doença de Chagas, com foco no fortalecimento da vigilância passiva e na organização digital das informações coletadas em campo. A vigilância passiva ocorre quando a própria população encontra um possível barbeiro e comunica a ocorrência às autoridades de saúde. Pensando nesse processo, o aplicativo possui uma aba chamada Comunidade, onde qualquer cidadão pode registrar uma denúncia enviando uma fotografia do inseto, uma breve descrição e a localização geográfica do local onde ele foi encontrado. Essas informações passam a integrar um banco de dados que contribui para a construção do mapa de vigilância entomológica.
                        </p>
                        <p>
                            Quando o município participa do projeto, essas notificações ficam disponíveis para avaliação do agente de combate às endemias responsável pela localidade, que pode analisar a imagem enviada e realizar a verificação em campo. Além da participação da comunidade, o aplicativo também possui uma área voltada ao trabalho dos agentes de campo. Por meio dela, os agentes registram visitas georreferenciadas decorrentes de denúncias da população ou de ações programadas de rotina, contribuindo também para a vigilância ativa. O sistema disponibiliza formulários digitais estruturados que substituem as fichas físicas tradicionais e permitem o registro padronizado das informações necessárias à vigilância.
                        </p>
                        <p>
                            As informações registradas em campo são integradas a um painel de monitoramento que consolida os dados e permite ao gestor visualizar o território de forma estratégica, em tempo real. O sistema automatiza a geração de indicadores entomológicos, permitindo que o município direcione as ações de controle de forma mais eficiente. Nossa proposta conquistou o segundo lugar no Desafio StartUFPI 2025, uma premiação que buscou destacar equipes com ideias inovadoras alinhadas aos Objetivos de Desenvolvimento Sustentável da ONU.
                        </p>

                        {/* BANNER ESTILO STRIPE ABAIXO DE TODO O TEXTO ATUALIZADO */}
                        <div className="stripe-banner-container">
                            <img src={startUfpiImage} alt="Equipe Vector Tracker 2º Lugar" className="stripe-banner-image" />
                            <div className="stripe-banner-overlay">
                                <div className="stripe-banner-top">
                                    <h3 className="stripe-banner-title">Nosso projeto conquistou o 2º lugar no<br />Desafio StartUFPI 2025</h3>
                                    <a href="https://ufpi.br/ultimas-noticias-ufpi/64701-desafio-startufpi-2025-equipe-cria-aplicativo-para-ajudar-a-identificar-o-inseto-vetor-da-doenca-de-chagas" className="stripe-banner-button" target="_blank" rel="noopener noreferrer">
                                        <span>Leia a matéria</span> <span className="heavy-arrow">→</span>
                                    </a>
                                </div>

                                <div className="stripe-banner-bottom">
                                    <div className="stripe-banner-brand">vector tracker</div>
                                    <div className="stripe-banner-info">
                                        <div className="info-item">
                                            <p>Fonte: Portal da UFPI</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="baixe-o-app-section">
                    <h2>O Que é a Doença de Chagas?</h2>
                    <div className="section-body">
                        <p>
                            A Doença de Chagas é uma infecção causada pelo protozoário <i>Trypanosoma cruzi</i> e representa um sério desafio para a saúde pública em todo o território brasileiro. Ela é reconhecida como uma das principais causas de morte por parasitas no país, sendo responsável por vitimar aproximadamente 4,5 mil pessoas anualmente. A enfermidade pode se manifestar inicialmente de forma aguda e evoluir para uma fase crônica que muitas vezes permanece silenciosa por décadas, até que surjam complicações graves em órgãos como o coração ou o sistema digestivo, podendo causar o aumento desses órgãos e sérios problemas de saúde.
                        </p>
                        <p>
                            O barbeiro é o inseto responsável pela transmissão e pertence à subfamília <i>Triatominae</i>, que possui mais de 60 espécies identificadas no Brasil. Para identificá-lo corretamente, é preciso observar se ele possui o bico (rostro) reto e fino dividido em apenas três partes, detalhe diferenciando-o de outros percevejos, como os fitófagos (que se alimentam de plantas), os quais possuem bico de 4 partes e não transmitem a doença. Os insetos adultos apresentam asas com a base parda e a ponta transparente, exibindo padrões de cores como o marrom-escuro ou preto com manchas em tons de amarelo, alaranjado ou vermelho nas bordas do abdômen. Possuem hábitos noturnos, evitam a luz e, durante o dia, procuram esconderijos em frestas de paredes de taipa ou madeira, atrás de quadros, sob colchões ou em anexos como galinheiros, chiqueiros e ninhos de pássaros.
                        </p>
                        <p>
                            A transmissão da doença não ocorre diretamente pela picada, mas sim pelas fezes que o barbeiro elimina enquanto se alimenta. A infecção acontece quando o parasita penetra no corpo por meio da ferida ou mucosa, geralmente quando a pessoa se coça e leva os resíduos para a área lesada ou para os olhos e boca. Além dessa via, a doença pode ser transmitida pela ingestão de alimentos contaminados com o inseto ou suas fezes, como o caldo de cana e o açaí, de forma vertical (da mãe para o filho na gravidez), por transfusões de sangue ou transplantes de órgãos. A doença apresenta uma fase aguda com sintomas como febre prolongada, dor de cabeça e mal-estar, além do sinal de Romaña (inchaço em um dos olhos), progredindo para a fase crônica caso não receba o tratamento devido.
                        </p>
                        <p>
                            A principal estratégia de prevenção é evitar a instalação dos barbeiros dentro e ao redor das habitações, o que inclui vedar frestas nas paredes, manter o quintal limpo de entulhos e afastar abrigos de animais das residências. Recomenda-se também o uso de telas em janelas e uma higiene rigorosa dos alimentos para prevenir a transmissão oral. É fundamental buscar atendimento médico caso a pessoa apresente febre persistente e tenha histórico de exposição em áreas onde o barbeiro foi encontrado. O diagnóstico rápido, feito através de exames de sangue específicos, é essencial para garantir o sucesso do tratamento e evitar complicações futuras, sendo o acompanhamento médico a única forma segura de lidar com a enfermidade.
                        </p>
                    </div>

                    {/* SEÇÃO HERO TRANSFORMADA EM FAIXA APÓS O TEXTO */}
                    <div className="hero-container stripe-hero" id="baixar-app-card">
                        <Particles
                            id="tsparticles"
                            particlesLoaded={particlesLoaded}
                            options={options}
                        />
                        <div className="hero-content-grid">
                            <div className="hero-text">
                                <div className="text-content-wrapper">
                                    <h1>Baixe nosso aplicativo e faça uma denúncia</h1>
                                    <p className="download-availability">
                                        Nosso objetivo é transformar denúncias em informação clara e acessível para apoiar o combate à Doença de Chagas.
                                        <br />Disponível para download em dispositivos Android.
                                    </p>

                                    <div className="download-buttons-group">
                                        <div className="playstore-button-wrapper">
                                            <a 
                                                href="https://play.google.com/store/apps/details?id=com.vectortrackers.app" 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                className="google-play-button"
                                            >
                                                <div className="google-play-content">
                                                    <img src={playstoreIcon} alt="Google Play Store" className="playstore-icon-img" />
                                                    <div className="google-play-text">
                                                        <span className="get-it-on">GET IT ON</span>
                                                        <span className="play-brand">Google Play</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                        <a href="https://app.vectortrackers.com" target="_blank" rel="noopener noreferrer" className="white-web-app-button">
                                            App Versão Web
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="hero-image">
                                <img src={celularComPrintImage} alt="Celular com print do aplicativo Vector Tracker" />
                            </div>
                        </div>
                    </div>
                </section>

                <section id="contato-section">
                    <h2>Contato</h2>
                    <p className="contact-subtitle">Precisa de ajuda ou tem alguma sugestão? Fale conosco.</p>
                    <div className="contact-info">
                        <a href="mailto:contato@vectortrackers.com">contato@vectortrackers.com</a>
                        <a href="tel:86981574244">(86) 98157-4244</a>
                    </div>
                </section>
            </main>
            <footer className="landing-footer">
                <div className="footer-content">
                    <div className="footer-brand">
                        <img src={logo} alt="Vector Tracker Logo" className="footer-logo" />
                        <span>Vector Tracker</span>
                    </div>
                    <div className="footer-links">
                        <h4>Políticas</h4>
                        <Link to="/politica-de-privacidade">Política de Privacidade</Link>
                        <Link to="/manual-de-uso">Manual de Uso</Link>
                    </div>
                </div>
                <div className="footer-separator"></div>
                <div className="footer-bottom">
                    <p className="company-info">VECTOR TRACKER SOLUCOES DIGITAIS INOVA SIMPLES (I.S.) | 64.785.501/0001-03</p>
                    <div className="footer-legal-row">
                        <p>© 2026 Vector Tracker</p>
                        <span className="separator">•</span>
                        <p className="credits">
                            Créditos da imagem (Topo): <a href="https://commons.wikimedia.org/wiki/File:Triatoma_brasiliensis.jpg" target="_blank" rel="noopener noreferrer">Triatoma brasiliensis</a> por Zezinho68 / <a href="https://creativecommons.org/licenses/by-sa/4.0/" target="_blank" rel="noopener noreferrer">CC BY-SA 4.0</a> (modificada: fundo removido)
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default LandingPage;
